<template>
  <div class="setting-main-container">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('profile.financial_facilities.financial_facilities') }}</h3>
        </div>
        <div class="page-header">
            <div class="row">
                <div class="col-md-8"></div>
                <div class="col-md-4 d-flex flex-row-reverse">
                    <base-button
                    outline
                    class="add-new-tax"
                    color="theme"
                    @click="addFinancialFacility"
                    >
                    {{ $t('profile.financial_facilities.add_new') }}
                    </base-button>
                </div>
            </div>
        </div>
        <table-component
            ref="financialFacilityTable"
            :show-filter="false"
            :data="financialFacilities"
            table-class="table tax-table"
            class="mb-3"
            >
            <table-column
              :sortable="true"
              :label="$t('profile.financial_facilities.s_no')"
              show="s_no"
            />
           
            <table-column
            :label="$t('profile.financial_facilities.amount')"
            show="amount"
            >
            <template slot-scope="row">
                <span> {{ $t('profile.financial_facilities.amount') }} </span>
                <div v-html="$utils.formatMoney(row.amount, defaultCurrency)" />
            </template>
            </table-column>

            <table-column
              :sortable="true"
              :label="$t('profile.financial_facilities.facility_nature')"
              show="facility_nature"
            />

            <table-column
              :sortable="false"
              :filterable="false"
              cell-class="action-dropdown"
            >
              <template slot-scope="row">
                <span>{{ $t('profile.financial_facilities.action') }}</span>
                <v-dropdown>
                  <a slot="activator" href="#">
                    <dot-icon />
                  </a>
                  <v-dropdown-item>
                    <div class="dropdown-item" @click="editFinancialFacility(row)">
                      <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon" />
                      {{ $t('general.edit') }}
                    </div>
                  </v-dropdown-item>
                </v-dropdown>
              </template>
            </table-column>
            
        </table-component>
      
        
      </div>
    
  </div>
</template>
<script>
import IconUpload from '../../components/icon/upload'
import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      isLoading: false,
    }
  },
computed: {
   ...mapGetters('financialFacility', [
      'financialFacilities'
    ]),
     ...mapGetters('currency', [
      'defaultCurrency'
    ]),
   
  }, 
  watch: {
  },
  validations: {
  },
  mounted () {
    
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),  
    addFinancialFacility(){
       this.openModal({
        'title': 'Add Financial Facility',
        'componentName': 'FinancialFacilityModal',
      })
      this.$refs.financialFacilityTable.refresh()
    },
    editFinancialFacility(data){
       this.openModal({
        'title': 'Edit Financial Facility',
        'componentName': 'FinancialFacilityModal',
        'id': data.id,
        'data': data
      })
      this.$refs.financialFacilityTable.refresh()
    },
  }
}
</script>
